import { boot } from 'quasar/wrappers';

export default boot(async({ store, router }) => {
   router.afterEach((to, from) => {
      if (from && from.matched.length && !from.meta.guest) {
         store.commit('nav/push', from);
      }
   });
});
